// extracted by mini-css-extract-plugin
export var arrow = "_2b-6";
export var changeItem = "_2b-3";
export var changesHeader = "_2b-1";
export var changesList = "_2b-2";
export var container = "_2b-0";
export var pathLabel = "_2b-4";
export var value = "_2b-7";
export var valuesContainer = "_2b-5";